import React from 'react'
import ReactDateTimePicker from 'react-datetime-picker'
import ReactTimePicker from 'react-time-picker'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Clear, ScheduleOutlined, Tune } from '@material-ui/icons'
import moment from 'moment-timezone'

const useStyles = makeStyles((theme: Theme) => ({
  timePicker: {
    boxSizing: 'border-box',
    fontFamily: `'Roboto', 'Helvetica', 'Arial', sans-serif`,
    fontSize: '16px',
    lineHeight: '19px',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.87)',
    width: '100%',
    '& .react-time-picker__wrapper': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '4px',
      padding: '12px 14px',
      width: '100%',
      color: 'black'
    },
    '& .react-time-picker__calendar': {
      zIndex: 100
    }
  }
}))

const TimePicker: React.FC<{
  label?: string
  value: Date | null
  pickerHandler: (time: Date | null) => void
  required?: boolean
}> = ({ label, value, pickerHandler, required = false }) => {
  const classes = useStyles({})

  return (
    <ReactTimePicker
      clearIcon={<Clear />}
      className={classes.timePicker}
      onChange={(time: any) => {
        console.log(time)
        pickerHandler(new Date(`1900-01-01 ${time === null ? '00:00' : time}`))
      }}
      value={value}
      required={required}
      format={'HH時mm分'}
      disableClock={true}
    />
  )
}

export default TimePicker
